import useMutation from '@/core/hooks/useMutation/useMutation';

export default useMutation;
